import { ref } from 'vue';
import { defineStore } from 'pinia';

/** Topbar sarlavhasi/nonushta yo'li — view'lar route meta'dan tashqari o'zi belgilashi mumkin */
export const useChromeStore = defineStore('chrome', () => {
  const title = ref<string | null>(null);
  const crumbs = ref<
    { label: string; to?: { name: string; params?: Record<string, string | number> } }[]
  >([]);

  function set(t: string | null, c: typeof crumbs.value = []): void {
    title.value = t;
    crumbs.value = c;
  }
  function reset(): void {
    title.value = null;
    crumbs.value = [];
  }
  return { title, crumbs, set, reset };
});
